import '../../node_modules/jssocials/dist/jssocials.js';
import '../../node_modules/jssocials/dist/jssocials-theme-flat.css';
import './less/jssocials.less';

import { Translate } from '../../hoc/translate';

const Socials = props => {
    let news = $('#single-news');
    let shareLink = news.data('share');
    let shareTitle = news.data('title');
    const selector = props.selector;
    
    let additionalCopyButton = ``;
    
    const init = () => {
        console.log('initialized');
        $(selector).jsSocials({
            url: shareLink,
            text: shareTitle,
            showLabel: false,
            showCount: false,
            shares: ['twitter', 'facebook', 'linkedin', 'email'],
        });
        
       // document.querySelector('.jssocials-shares').insertAdjacentHTML('beforeend',additionalCopyButton);
    };
    
    init();
};


export default Translate(Socials);


// WEBPACK FOOTER //
// ./components/jssocials/jssocials.js